import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Mail } from 'lucide-react';
import { useTheme } from '../../core/contexts/ThemeContext';
export function ContactApp() {
  const {
    theme,
    t
  } = useTheme();
  const isLightTheme = theme === 'light';
  return <div className="h-full overflow-y-auto p-5 md:p-16 pb-28" data-id="element-18" data-mp="gn6x4jnjia82">
      <div className="flex flex-col justify-center min-h-full" data-id="element-19" data-mp="bnkhy4o5ijwm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 28
      }} className="max-w-2xl mx-auto w-full space-y-12 md:space-y-16" data-id="element-20" data-mp="3k1jcd1vh5x80">
          <div className="space-y-5" data-id="element-21" data-mp="3p3ifcanays4f">
            <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-22" data-mp="1998d6m8vew6k">
              {t('contact.heading')}
            </h1>
            <p className={`text-lg sm:text-xl ${isLightTheme ? 'text-[#6B6B6B]' : 'text-[#9B9B9B]'}`} data-id="element-23" data-mp="23nmtf2apcqzj">
              {t('contact.availability')}
            </p>
          </div>

          <div className="space-y-10" data-id="element-24" data-mp="2dmu9hx8tmzqc">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-25" data-mp="2hnxokhj1orqi">
              <a href="mailto:mick@mvlcreative.com" className={`flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-medium transition-all shadow-sm flex-1 ${isLightTheme ? 'bg-white border border-black/[0.06] text-[#1A1A1A] hover:bg-black/5' : 'bg-[#1A1A1A] border border-white/[0.06] text-[#E8E8E6] hover:bg-white/5'}`} data-id="element-26" data-mp="2hn4n9w2uuufr">
                <Mail className="w-5 h-5" data-id="element-27" data-mp="1ypv2oblsnawx" />
                mick@mvlcreative.com
              </a>
              <a href="https://calendly.com/mick-mvlcreative/30min" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 px-8 py-4 rounded-xl bg-[#C8956C] text-white font-medium hover:bg-[#B5825A] transition-all shadow-lg shadow-[#C8956C]/20 flex-1" data-id="element-28" data-mp="126dzijg1dbav">
                <Calendar className="w-5 h-5" data-id="element-29" data-mp="2j9ziwp4mtc86" />
                {t('contact.cta_call')}
              </a>
            </div>

            <div className={`grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12 pt-10 border-t ${isLightTheme ? 'border-black/[0.06]' : 'border-white/[0.06]'}`} data-id="element-30" data-mp="2ebpnqeiwqbmk">
              <div className="space-y-3" data-id="element-31" data-mp="1lmin99zw7byo">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-32" data-mp="1lntvbm0df5vl">
                  {t('contact.phone_label')}
                </div>
                <a href="tel:0651244475" className={`inline-block text-lg md:text-xl transition-all hover:text-[#C8956C] hover:underline underline-offset-4 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-33" data-mp="1viu3gb2lslye">
                  0651244475
                </a>
              </div>

              <div className="space-y-3" data-id="element-34" data-mp="3eko0grrlimge">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-35" data-mp="3ji7f3ss7h18v">
                  {t('contact.social_label')}
                </div>
                <div className="flex flex-col items-start gap-2" data-id="element-36" data-mp="34mi22k4zzyga">
                  <a href="https://linkedin.com/in/mick-van-latum" target="_blank" rel="noopener noreferrer" className={`inline-block text-lg md:text-xl transition-all hover:text-[#C8956C] hover:underline underline-offset-4 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-37" data-mp="39k9s18m31ahu">
                    LinkedIn ↗
                  </a>
                  <a href="https://www.tiktok.com/@ai_deal_with_it" target="_blank" rel="noopener noreferrer" className={`inline-block text-lg md:text-xl transition-all hover:text-[#C8956C] hover:underline underline-offset-4 ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-38" data-mp="3sg9oowq0927r">
                    TikTok · @ai_deal_with_it ↗
                  </a>
                </div>
              </div>

              <div className="space-y-3" data-id="element-39" data-mp="2ne8m7ucdji9c">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-40" data-mp="2idkwdbzvt7gp">
                  {t('contact.location_label')}
                </div>
                <div className={`text-lg md:text-xl ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-41" data-mp="3g2wg2eb6vfyi">
                  {t('contact.location')}
                </div>
              </div>

              <div className="space-y-3" data-id="element-42" data-mp="31c72j5a99orh">
                <div className="font-mono text-xs uppercase tracking-widest text-[#C8956C]" data-id="element-43" data-mp="31be0ghm8rnfo">
                  {t('contact.status_label')}
                </div>
                <div className={`flex items-center gap-3 text-lg md:text-xl ${isLightTheme ? 'text-[#1A1A1A]' : 'text-[#E8E8E6]'}`} data-id="element-44" data-mp="3u02rtoxhwee8">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#27C93F] animate-pulse" data-id="element-45" data-mp="667c2chsqn6l" />
                  {t('contact.status')}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}